<p-dialog
  [visible]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [closable]="false"
  styleClass="!rounded-[2rem] overflow-hidden shadow-2xl"
  contentStyleClass="!p-0"
  [style]="{ width: '560px' }"
  [breakpoints]="{ '640px': '92vw' }"
  (onHide)="close.emit()"
>
  <div class="w-full flex flex-col max-h-[80vh] bg-white">
    <!-- Header -->
    <div class="relative px-7 pt-7 pb-6 border-b border-slate-100">
      <button
        (click)="close.emit()"
        class="absolute top-5 right-5 w-9 h-9 flex items-center justify-center rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all">
        <i class="pi pi-times text-sm"></i>
      </button>

      <div class="flex items-center gap-4 pr-10">
        <div class="w-12 h-12 rounded-2xl bg-primary/10 text-primary flex items-center justify-center shrink-0 border border-primary/10 shadow-sm">
          <i class="pi pi-users text-lg"></i>
        </div>
        <div class="flex flex-col gap-1 overflow-hidden">
          <h2 class="text-lg font-black text-slate-900 tracking-tight leading-none truncate">
            {{ 'settings_profile_details' | translate }}
          </h2>
          <div class="flex items-center gap-2">
            <span class="text-sm font-semibold text-slate-500 truncate">{{ profileName }}</span>
            <span *ngIf="!loading"
              class="inline-flex items-center gap-1 text-[10px] font-black uppercase tracking-wider text-primary bg-primary/10 border border-primary/20 px-2 py-0.5 rounded-full shrink-0">
              {{ users.length }} {{ 'settings_profile_users' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="px-5 py-5 overflow-y-auto min-h-[280px]">
      <!-- Loading State -->
      <div *ngIf="loading" class="flex flex-col gap-3">
        <div *ngFor="let i of [1,2,3]" class="flex items-center gap-4 p-3 animate-pulse">
          <div class="w-12 h-12 bg-slate-100 rounded-2xl shrink-0"></div>
          <div class="flex flex-col gap-2 w-full">
            <div class="h-3.5 bg-slate-100 rounded-full w-1/2"></div>
            <div class="h-3 bg-slate-100 rounded-full w-1/3"></div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && users.length === 0"
        class="flex flex-col items-center justify-center py-16 text-slate-400 gap-4">
        <div class="w-16 h-16 rounded-[2rem] bg-slate-50 flex items-center justify-center">
          <i class="pi pi-users text-2xl opacity-40"></i>
        </div>
        <span class="text-sm font-bold tracking-tight">{{ 'settings_profile_no_users' | translate }}</span>
      </div>

      <!-- Users List -->
      <div *ngIf="!loading && users.length > 0" class="flex flex-col gap-1">
        <div *ngFor="let user of users"
          class="flex items-center justify-between gap-4 group p-3 rounded-2xl hover:bg-slate-50 transition-all border border-transparent hover:border-slate-100">
          <div class="flex items-center gap-4 overflow-hidden">
            <!-- Avatar -->
            <div class="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary/15 to-primary/5 text-primary flex items-center justify-center font-black text-xs shrink-0 shadow-sm border border-primary/10 overflow-hidden">
              <img *ngIf="user.photo_url" [src]="user.photo_url" class="w-full h-full object-cover">
              <span *ngIf="!user.photo_url">{{ getInitials(user.name || user.email) }}</span>
            </div>
            <!-- Info -->
            <div class="flex flex-col overflow-hidden gap-0.5">
              <div class="flex items-center gap-2">
                <span class="text-sm font-bold text-slate-800 truncate">{{ user.name || ('user_no_name' | translate) }}</span>
                <span *ngIf="user.user_type_name"
                      [ngClass]="userTypeBadge.getClasses(user.user_type_id, user.user_type_name)"
                      class="shrink-0 px-2 py-0.5 rounded-full border text-[10px] font-black uppercase tracking-wide">
                  {{ user.user_type_name }}
                </span>
              </div>
              <span class="text-xs font-semibold text-slate-400 truncate opacity-80">{{ user.email }}</span>
            </div>
          </div>

          <!-- Remove User Action -->
          <button (click)="confirmRemoveUser(user)"
            [title]="'delete' | translate"
            class="w-9 h-9 flex items-center justify-center text-slate-300 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all opacity-0 group-hover:opacity-100 focus:opacity-100 shrink-0">
            <i class="pi pi-trash text-sm"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-7 py-5 border-t border-slate-100 flex justify-end bg-slate-50/40">
      <app-button
        [label]="'close' | translate"
        variant="secondary"
        (onClick)="close.emit()"
        class="w-full sm:w-auto">
      </app-button>
    </div>
  </div>
</p-dialog>

<!-- Remove-user confirmation (rendered above the modal) -->
<p-confirmDialog
  key="removeUserConfirm"
  appendTo="body"
  [baseZIndex]="20000"
  styleClass="premium-confirm-dialog"
  acceptButtonStyleClass="!bg-rose-500 !border-rose-500 !rounded-xl !px-6 !text-white hover:!bg-rose-600"
  rejectButtonStyleClass="p-button-text !rounded-xl !px-6 !text-slate-500">
</p-confirmDialog>
